<template>
  <div class="post">
    <BlogNav></BlogNav>
    <!-- vue-highlight用法 -->
    <!-- Code Block -->
    <!--
    <highlight-code lang="vue">
      &lt;input type=&quot;button&quot; onclick=&quot;audio.play()&quot; value=&quot;播放&quot; /&gt;
    </highlight-code>
    -->
    <div class="post-ctx">
      <div class="md-body" v-html="md"></div>
    </div>
  </div>
</template>

<script>
import BlogNav from "@/components/BlogNav.vue";

export default {
  name: "post",
  components: {
    BlogNav
  },
  data() {
    return {
      md: null
    };
  },
  created() {
    let target = this.$route.query.target;
    this.$api.getPostDetails(target).then(res => {
      this.md = res.data;
    });
  },
  mounted() {
    this.$nextTick(() => {
      var links = document.links;
      for (let item of links) {
        if (item.hostname != window.location.hostname) {
          item.target = "_blank";
        }
      }
    });
  }
};
</script>

<style lang="less">
@import url("../../assets/markdown/style.less");
body {
  background-color: #f0f0f0;
}
.post {
  .post-ctx {
    width: 60rem;
    height: auto;
    background-color: #fff;
    margin: 1rem auto;
    .md-body {
      padding: 2rem 2.5rem;
    }
  }
}
@media screen and (max-width: 768px) {
  .post {
    .post-ctx {
      width: 100%;
      .md-body {
        padding: 1rem;
      }
    }
  }
}
</style>